<script setup>
// La celda sin dato: un guion apagado. Se repetía a mano en cada tabla y
// cada una lo escribía con su propio tamaño, así que vive aquí.
defineProps({
  label: { type: String, default: '—' },
});
</script>

<template>
  <span class="text-xs text-n-slate-9">{{ label }}</span>
</template>
